<template>
  <div class="d-flex flex-column border border-top-0 p-3 text-left">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th></th>
          <th>包裹查詢</th>
          <th>出貨單號</th>
          <th>實際出貨日</th>
          <th>內容物</th>
          <th>收件人</th>
          <th>地址</th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in pro_track_list" :key="index">
        <tr>
          <td>{{index + 1}}</td>
          <td>{{item.pro_track_from}}</td>
          <td>{{item.pro_track_id}}</td>
          <td>{{item.pro_track_date}}</td>
          <td><a href="#" @click.prevent="openInfo(item.pro_track_id)">{{item.pro_track_count}}</a>
          </td>
          <td>{{item.pro_track_receiver}}</td>
          <td>{{item.pro_track_address}}</td>
        </tr>
        <tr v-if="trackid === item.pro_track_id">
          <td></td>
          <td colspan="6">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>內容項目</th>
                  <th>數量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(j, index) in item.pro_track_info" :key="index">
                  <td>{{j.name}}</td>
                  <td>{{j.count}}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      trackid: '',
    };
  },
  methods: {
    openInfo(id) {
      this.trackid = id;
    },
  },
  computed: {

    pro_track_list: {
      get() {
        return this.$store.state.ship.pro_track_list;
      },
    },
  },
};

</script>

<style>

</style>
